module.exports = __webpack_public_path__ + "static/media/fire-safes-with-usb.d10ec55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/fire-safes-with-usb.png
// module id = 1286
// module chunks = 0